import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TratamentosPage = lazy(() => import('../pages/tratamentos/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const PrivacidadePage = lazy(() => import('../pages/privacidade/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/tratamentos',
    element: <TratamentosPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/privacidade',
    element: <PrivacidadePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
